var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3728",
    "data-name": "Rectangle 3728",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g271",
    transform: "translate(0.586 1.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g277",
    transform: "translate(3.515 1.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path279",
    d: "M62.73,57.421v2.344H78.043V44.53H62.73v3.515H78.043",
    transform: "translate(-62.73 -44.53)",
    fill: "none",
    stroke: "#1b453e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g281",
    transform: "translate(7.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path283",
    d: "M116.05,26.95v2.344",
    transform: "translate(-116.05 -26.95)",
    fill: "none",
    stroke: "#1b453e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g285",
    transform: "translate(15.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path287",
    d: "M239.69,26.95v2.344",
    transform: "translate(-239.69 -26.95)",
    fill: "none",
    stroke: "#1b453e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g289",
    transform: "translate(11.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path291",
    d: "M177.58,26.95v2.344",
    transform: "translate(-177.58 -26.95)",
    fill: "none",
    stroke: "#1b453e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g293",
    transform: "translate(0 4.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path295",
    d: "M13.515,97.27c0,6.445-3.515,9.375-3.515,9.375H25.313s3.515-2.93,3.515-9.375",
    transform: "translate(-10 -97.27)",
    fill: "none",
    stroke: "#1b453e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cbf0489a732a5db295f758aa40da37d1.svg";
export { ForwardRef as ReactComponent };